import React from 'react';
import { useUserDataContext } from 'components/UserDataContext/context';
import { ROLES } from 'utils/consts/roles';
import { useGetPermission } from 'utils/hooks/useGetPermission';

import styles from './CerberusIntegrationStatus.module.scss';

interface IProps {
  isEnteredManually?: boolean;
  isNotLinkedWithCerberus?: boolean;
}
export const CerberusIntegrationStatus: React.FC<IProps> = ({
  isEnteredManually,
  isNotLinkedWithCerberus,
}) => {
  const { userData } = useUserDataContext();
  const hasPermission = useGetPermission(ROLES.cerberus, userData);

  return (
    (hasPermission && (isEnteredManually || isNotLinkedWithCerberus) && (
      <p className={styles.wrapper}>
        {isEnteredManually && <i>ХС введен вручную</i>}
        {isNotLinkedWithCerberus && <i>ХС не связан с Цербер</i>}
      </p>
    )) ||
    null
  );
};
